import { isArray } from 'util';
import './components/cookies';

var slickSliderOptions = {
    prevArrow: '<button class="RoundButton slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon arrow-left"></i></button>',
    nextArrow: '<button class="RoundButton slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon arrow-right"></i></button>',
    dots: true
};

$('[data-slider]').each( function(index, item) {

    var tthis = $(item);
    var options = $.extend(slickSliderOptions, tthis.data('slider'));

    if (!isArray(options.responsive)) {
        options.responsive = [];
    }

    if (tthis.data('slides-tablet')) {
        options.responsive.push({
            breakpoint: 768,
            settings: {
                slidesToShow: tthis.data('slides-tablet'),
                slidesToScroll: tthis.data('slides-tablet')
            }
        });
    }

    if (tthis.data('slides-desktop')) {
        options.responsive.push({
            breakpoint: 1025,
            settings: {
                slidesToShow: tthis.data('slides-desktop'),
                slidesToScroll: tthis.data('slides-desktop')
            }
        });
    }

    tthis.slick(options);

    var maxHeight;

    setTimeout( function() {

		if ( options.slide ) {
			var $slides = tthis.find( options.slide );
			$slides.each( function(i, slide) {
				if (slide.clientHeight < maxHeight || !maxHeight) {
					maxHeight = slide.clientHeight;
				}
			});
			tthis.find(options.slide).parent().css('max-height', maxHeight);
		} else {
			var $images = tthis.find('img');
			$images.each( function(i, img) {
				if (img.clientHeight < maxHeight || !maxHeight) {
					maxHeight = img.clientHeight;
				}
			});

			tthis.find('img').parent().css('max-height', maxHeight);
		}

    }, 300);

    $(window).on('resize', function() {

        tthis.find('img').parent().css('max-height', 'none');

        maxHeight = false;

        setTimeout( function() {

			if ( options.slide ) {
				var $slides = tthis.find( options.slide );
				$slides.each( function(i, slide) {
					if (slide.clientHeight < maxHeight || !maxHeight) {
						maxHeight = slide.clientHeight;
					}
				});
				tthis.find(options.slide).parent().css('max-height', maxHeight);
			} else {
				var $images = tthis.find('img');
				$images.each( function(i, img) {
					if (img.clientHeight < maxHeight || !maxHeight) {
						maxHeight = img.clientHeight;
					}
				});

				tthis.find('img').parent().css('max-height', maxHeight);
			}
        }, 300);
    });


});


$('.Header__HB').on('click', function() {
    $('body').toggleClass('show-menu');
});

$('.Header__Search, .Search .Search__Close').on('click', function() {
    $('body').toggleClass('show-search');
});

if ( $('.Header--SicurnetBusiness').length > 0 ) {
	var offsetToCheck = $('.Header--SicurnetBusiness').offset().top,
		subHeaderHeight = $('.Header--SicurnetBusiness').innerHeight();
}

$(window).on('scroll', function() {

    if ($(window).scrollTop() > 0) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }

    if ( $('.Header--SicurnetBusiness').length > 0 ) {
		if ($(window).scrollTop() > offsetToCheck ) {
			$('.Header--SicurnetBusiness').addClass('sticky');
		} else {
			$('.Header--SicurnetBusiness').removeClass('sticky');
		}
	}
});



$('.ButtonToTop').on('click', function() {
    $('html,body').animate({ scrollTop: 0 });
});

$('.Header--SicurnetBusiness .Header__Nav a').on('click', function() {
	$('html,body').animate({ scrollTop: $( $(this).attr('href') ).offset().top - subHeaderHeight });
});

$('.Filters a').on('click', function(e) {
    e.preventDefault();
    var cat = $(this).data('cat');

    if ($(this).parent().hasClass('active')) return;

    $('.Filters li').removeClass('active');
    $(this).parent().addClass('active');

    if (cat == '*') {
        $('.FilterItem').stop(true, true).animate({ opacity: 0 }, 300, function() {
            $('.FilterItem').show().animate({ opacity: 1});
        });
    } else {
        $('.FilterItem').stop(true, true).animate({ opacity: 0 }, 300, function() {

            $('.FilterItem').filter(function() {
                return !$(this).hasClass('cat-' + cat);
            }).animate({opacity: 0},300,  function() {
                $(this).hide();
            });

            setTimeout(function() {
                $('.FilterItem').filter(function() {
                    return $(this).hasClass('cat-' + cat);
                }).show().animate({opacity: 1}, 300);
            }, 250)


        });
    }
});

$('.Faq__AnswersItem').on('faq:show', function() {

    var $item = $(this);
    if ($item.hasClass('active')) return;

    var contentHeight = $item.find('.Faq__AnswersContent').outerHeight();
    $item.find('.Faq__AnswersContainer').animate({height: contentHeight}, function() {
        $item.addClass('active');
        $item.find('.Faq__AnswersContainer').removeAttr('style');
        $('html, body').animate({scrollTop: $item.offset().top - 100});
    });

});

$('.Faq__AnswersItem').on('faq:hide', function() {

    var $item = $(this);
    if (!$item.hasClass('active')) return;

    $item.find('.Faq__AnswersContainer').animate({height: 0}, function() {
        $item.removeClass('active');
        $item.find('.Faq__AnswersContainer').removeAttr('style');
    });

});

$('.Faq__AnswersItem .Faq__AnswersTitle').on('click', function(e) {
    e.preventDefault();
    var $item = $(this).closest('.Faq__AnswersItem');

    if ($item.hasClass('active'))  {
        $item.trigger('faq:hide');
    } else {
        $('.Faq__AnswersItem').not($item).trigger('faq:hide');
        $(this).closest('.Faq__AnswersItem').trigger('faq:show');
    }

});

$('#contacts-trigger').on('click', function(e) {
    e.preventDefault();
    var contactsHeight = $('#contacts-form > div').outerHeight();
    $('#contacts-form').animate({height: contactsHeight}, function(){
        $('#contacts-form').addClass('opened');
        $('#contacts-form').removeAttr('style');
    });
})

$('#contacts-form .Search__Close').on('click', function(e) {
    e.preventDefault();
    $('#contacts-form').animate({height: 0});
})

function serviceHeaderContainerSize() {

    $('[data-header-container]').height($('.Header').outerHeight());

}

if ($('body').hasClass('layout-service')) {

    var serviceOffsetHeight = $('.Header__Top').outerHeight();
    var serviceHeaderOffset = $('[data-header-offset]').outerHeight();

    $(window).on('resize', function() {
        serviceHeaderContainerSize();
        serviceOffsetHeight = $('.Header__Top').outerHeight();
        serviceHeaderOffset = $('[data-header-offset]').outerHeight();
    });

    $(window).on('load', function() {
        serviceHeaderContainerSize();
    })

    $(window).on('scroll', function() {
        if ($(window).scrollTop() > serviceHeaderOffset) {
            var offset = $(window).scrollTop() - serviceHeaderOffset;
            $('.Header__Top').css('top', offset * -1);
            if (offset > serviceOffsetHeight) {
                $('body').addClass('service-header-fixed');
            } else {
                $('body').removeClass('service-header-fixed');
            }
        } else {
            $('.Header__Top').css('top', 0);
            $('body').removeClass('service-header-fixed');
        }
    })

}

// $('.Tooltip__Button').on('click', function() {
//     $(this).closest('.Tooltip').toggleClass('show');
// })

// $('.Tooltip').on('mouseleave', function() {
//     $(this).removeClass('show');
// })



// WEBPACK FOOTER //
// ./js/app.js